<template>
	<div style="padding-bottom: 100px;">
		<div class="van-hairline--bottom r-title">退款订单信息</div>
		<div style="font-size: 15px;">
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">订单编号：</span>
				<span style="flex: 1;text-align: left;">{{order.out_trade_no}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">退单编号：</span>
				<span style="flex: 1;text-align: left;">{{order.out_refund_no}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">支付方式：</span>
				<span style="flex: 1;text-align: left;" v-if="order.pay_type">{{order.pay_type =='wxpay' ? '微信支付' :'支付宝' }}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">订单金额：</span>
				<span style="flex: 1;text-align: left;" v-if="order.total_fee">￥{{order.total_fee}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">退款金额：</span>
				<span style="flex: 1;text-align: left;" v-if="order.refund_amount">￥{{order.refund_amount}}</span>
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">退款进度：</span>
				<span style="flex: 1;text-align: left;" >{{returnStatus}} <van-tag type="warning" v-if="order.return_status == 1" style="margin-left: 10px;padding: 2px;" @click.stop='cancelRefundOrder(order.id)'>取消退款申请</van-tag></span>				
			</div>
			<div style="display: flex;margin-bottom: 2px;" >
				<span style="width: 30%;text-align: right;">客服电话：</span>
				<span style="flex: 1;text-align: left;" v-if="order.total_fee">400-006-8989</span>
			</div>
			
		</div>
		<div class="van-hairline--bottom r-title" style="display: flex;justify-content: space-between;"><span>退款进度</span> <span >{{returnStatus}}</span></div>	
		<van-steps :active="statuActive">
		  <van-step style="text-align: left;">申请退款<br><span>{{order.create_time}}</span></van-step>			  
		  <van-step style="text-align: right;">{{returnStatus}}<br><span v-if="order.check_time">{{order.check_time*1000 | formonment('YYYY-MM-DD HH:mm:ss')}}</span></van-step>
		</van-steps>
		
		<div v-if="order.return_status == 3 && order.memo">
			<div class="van-hairline--bottom r-title" style="margin: 0;padding-top: 0;">审核未通过原因</div>
			<div style="text-align: center;padding: 20px 20px;color: red;font-weight: 800;">{{order.memo}}</div>
		</div>
		
		<div class="van-hairline--bottom r-title">退款商品信息</div>
		<div style="text-align: left;">
			<div v-for="(item,index) in orderDetail" :key="index" style="margin-bottom: 10px;">
				<van-card
				  :price="item.price.toFixed(2)"
				  :desc="item.size ? item.size +'/'+item.unit_name:''"
				  :title="item.item_name"
				  :thumb="item.thumb_image"
				  style="flex: 1;"
				>
				<template #tags>
				    	<div style="text-align: right;">
							<div>申请退款 <span style="color: red;"> {{item.return_quantity}} </span> 件，合计<span style="color: red;">￥{{item.return_amount}} </span></div>
						</div>	    
				  </template>
				  <template #footer >					  
					 	<div>
							<van-button v-if="item.return_img[0]" size="mini" @click='openImg(item)' style="font-size: 13px;">查看图片</van-button>
							<div style="margin-top:5px;">退款原因：{{item.return_reason}}</div>
							<van-image-preview v-model="imgShow" :images="returnImgs"  :show-indicators='true' :closeable ='true' @close='closeImgShow'></van-image-preview>
						</div>		   
				  </template>
				</van-card>
			</div>
			<div style="text-align: right;padding-right: 20px;font-size: 15px;">合计金额: <span style="color: red;font-weight: 800;font-size: 16px;">￥{{order.refund_amount}}</span></div>
			
		</div>
	</div>
</template>

<script>
	export default{
		name:'returnOrderInfo',
		data(){
			return{
				order:{},
				orderDetail:[],
				imgShow: false,
				returnImgs:[],				      
			}
		},
		computed:{
			returnStatus(){
				let arr=['','审核中', '审核通过', '审核不通过','已取消']
				return arr[this.order.return_status]
			},
			statuActive(){
				if(this.order.return_status=='1'){
					return 0
				}else{
					return 1
				}
			}
		},
		methods:{
			openImg(item){
				this.currentItem = item
				this.returnImgs = item.return_img
				this.imgShow = true
			},
			//关闭查看图片
			closeImgShow(){
				this.returnImgs=[];			
			},
			//获取退款订单明细
			getRefundOrderDetail(id){
				const toast=this.$toast.loading({
				  message: '',
				  forbidClick: true,
				  loadingType: 'spinner',
				});
				
				this.request.postURL('/api/RefundOrder/getRefundOrderDetail',{
					id:id,
				}).then(res=>{
					toast.clear()
					this.order=res.data.data;
					this.orderDetail = res.data.data.order_detail
					
				}).catch(err=>{
					toast.clear()
				})
			},
			//待审核订单取消订单
			//用户取消退款
			cancelRefundOrder(id){
				this.$dialog.confirm({
				      message: '您确定要取消退款申请吗？',
				}).then(()=>{					
					const toast =this.$toast.loading({
					  duration: 0, // 持续展示 toast
					  forbidClick: true,
					  message: '',
					});
					this.request.postURL('/api/RefundOrder/cancelRefundOrder',{
						id:id
					}).then(res=>{
						toast.clear()						
						this.$dialog.alert({
						  message: res.data.data.action,
						}).then(() => {						 
						  this.$nextTick(()=>{
							 this.$router.go(-1)
						  })
						});
					}).catch(err=>{
						toast.clear()
					})
				}).catch(()=>{
					
				})				
			}
		},
		created() {
			var id =this.$route.query.id
			this.getRefundOrderDetail(id)
		}
		
		
	}
</script>

<style scoped>
	.r-title{
		text-align: left;
		font-size: 16px;
		font-weight: 800;
		padding:10px 20px;
		margin: 10px 0;
	}
	>>>.van-step__line ,>>>.van-step__circle-container{
		margin-top: 10px !important;
	}
</style>